import { render, staticRenderFns } from "./Step3AuthCode.vue?vue&type=template&id=9880c94e&scoped=true"
import script from "./Step3AuthCode.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3AuthCode.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step3AuthCode.vue?vue&type=style&index=0&id=9880c94e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9880c94e",
  null
  
)

export default component.exports